<template>
  <div>
    <h2 class="is-title is-size-4"><a @click="showMoreInfo = true" class="is-link">Legislação Colonial  (1910 - 1970)</a></h2>
    <div class="tabs is-centered">
      <ul>
        <li :class="active[0]"><a @click="activate(0)">Pesquisar</a></li>
        <li :class="active[1]"><a @click="activate(1)">Volumes</a></li>
      </ul>
    </div>
    <div v-if="active[0] === 'is-active'">
      <search-form class="is-basic-input" @searched="setDocuments" @goBack="goBack" v-if="isSearch"/>
      <display-results v-else :documents="documents" :term="term" :search-mode="searchMode" @back="isSearch = true" />
      <message-overlay :overlay-message="message" :information-type="'is-danger'"
                       v-if="hasMessage" @closed="hasMessage = false"/>
    </div>
    <div v-if="active[1] === 'is-active'">
      <view-works v-if="explore[0]" @view="showDocuments"/>
      <view-documents v-if="explore[1]" :work="work" @back="explore = [true, false]"/>
    </div>
    <message-overlay v-if="showMoreInfo" @closed="showMoreInfo = false" :overlay-message="moreInfoMessage" :information-type="'is-rules'" :is-html="true" />
  </div>
</template>

<script>

import SearchForm from "../components/partial/SearchForm";
import DisplayResults from "../components/partial/DisplayResults";
import MessageOverlay from "../components/generic/MessageOverlay";
import ViewWorks from "../components/partial/ViewWorks";
import ViewDocuments from "../components/partial/ViewDocuments";

export default {
name: "Search",
  components: {ViewDocuments, ViewWorks, MessageOverlay, DisplayResults, SearchForm},
  data:()=>({
    documents: [],
    term: '',
    searchMode:{},
    isWait: false,
    isSearch:true,
    hasMessage: false,
    message: '',
    active: ['is-active', ''],
    explore: [true, false],
    work: '',
    showMoreInfo: false,
    moreInfoMessage: "<h4 class=\"is-size-5\" style=\"color:#330000\">PESQUISA</h4><p class=\"block\">Na modalidade «pesquisa», o utilizador poderá combinar vários tipos de pesquisa.<br />Na versão mais simplificada - «Palavra(s) a pesquisar» – poderá pesquisar uma ou mais palavras (ou parte de palavras) à sua escolha. Ex: «tribunal», «tribun» ou «tribunal Angola». Após ter feito enter, esta palavra/expressão será pesquisada no texto de todas as espécies legislativas que constituem a base, volume a volume, devolvendo ao utilizador as páginas geradas pela pesquisa. <br />A correção de palavras que foram mal reconhecidas pelo software de captação das imagens foi realizada nos índices de cada um dos volumes. Quer isto dizer que só se garante que todas as palavras pesquisadas são efetivamente detetadas nesses índices (pesquisa «apenas no índice»). Mesmo aqui, porém, importa ter atenção para as possíveis diferentes grafias que uma palavra pode apresentar ao longo da cronologia a que se refere esta base de dados. Assim, para dar um exemplo, a pesquisa devolve resultados diferentes para «Loanda» e «Luanda», ou para «Governo» e «Govêrno».</p><h4 class=\"is-size-5\" style=\"color:#330000\">ABRANGÊNCIA DOCUMENTAL DA PESQUISA</h4><p class=\"block\">Caso deseje restringir a pesquisa aos índices dos volumes, poderá fazê-lo em «abrangência da pesquisa», optando aí pela pesquisa «apenas no índice».<br />Pode também optar por restringir a pesquisa a um só volume, selecionando, para isso, o volume pretendido, em «Documento».<br />Pode, finalmente, restringir temporalmente a sua pesquisa, escolhendo um período temporal preciso (de 1910 a 1970). Os resultados são apresentados por ordem cronológica.</p><h4 class=\"is-size-5\" style=\"color:#330000\">CONSULTA</h4><p class=\"block\">Na modalidade consulta, em «documentos», o utilizador poderá consultar, colecção a colecção, ou volume a volume, todos os livros e espécies digitalizadas nesta base de dados. Poderá ainda ler estes volumes como se de livros se tratassem, da primeira até à última página. Poderá, finalmente, clicar no índice de cada um destes livros e, dessa forma, aceder directamente às espécies legislativas que constam do índice.</p>"
  }),
  methods:{
    setDocuments(result){
      if(result.result.length !== 0){
        this.documents = result.result;
        this.term = result.term;
        this.searchMode = result.searchMode;
        this.isSearch = false;
      }else{
        this.documents = [];
        this.message = 'Nenhum resultado encontrado';
        this.hasMessage = true;
      }
    },
    activate(index){
      this.active = ['',''];
      this.active[index] = 'is-active';
    },
    showDocuments(work){
      this.work = work;
      this.explore = [false, true];
    },
    goBack(){
      this.$emit('goBack')
    },
  },
  created() {
    if(this.$route.params.documents != null){
      this.documents = this.$route.params.documents;
      this.term = this.$route.params.term;
      this.searchMode = this.$route.params.searchMode;
      this.active = ['is-active', ''];
      this.isSearch = false;
    }else if(this.$route.params.work != null){
      this.work = this.$route.params.work;
      this.active = ['', 'is-active'];
      this.explore = [false, true];
    }
  }
}
</script>

<style scoped>
.is-basic-input{
  width: 80%;
  margin-left: auto;
  margin-right: auto;
}

.is-title{
  text-align: center;
  margin-bottom: 40px;
  font-weight: bold;
  color: #330000;
}

.is-link{
  text-decoration: underline;
}
</style>